import React from 'react';
import styled from 'styled-components';
import colors from 'theme/colors';
import ScrollRow from './ScrollRow';

const accent = colors.occasionalPurple;

export default function TimeSlotPicker({ slots, value, onChange }) {
    if (!slots || slots.length === 0) return null;

    return (
        <ScrollRow ariaLabel='Horário'>
            {slots.map(time => (
                <Slot
                    key={time}
                    type='button'
                    $selected={time === value}
                    aria-pressed={time === value}
                    onClick={() => onChange(time)}
                >
                    {time}
                </Slot>
            ))}
        </ScrollRow>
    );
}

const Slot = styled.button`
    flex-shrink: 0;
    min-width: 72px;
    height: 40px;
    padding: 0 12px;
    border-radius: 8px;
    border: 1.5px solid ${accent};
    background: ${({ $selected }) => ($selected ? accent : '#fff')};
    color: ${({ $selected }) => ($selected ? '#fff' : accent)};
    font-size: 14px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
`;
